import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Form/Button';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { TbBrandFacebook, TbBrandInstagram, TbBrandPinterest, TbBrandTiktok, TbBrandX, TbBrandYoutube } from 'react-icons/tb';
import { handleNavigateToExternalLink, hasSocialLinks } from '../../Utils/Helpers';

interface BoxContentSocialProps {
    className?: string;
    onlyButtons?: boolean;
}

const BoxContentSocial = ({
    className,
    onlyButtons,
}: BoxContentSocialProps) => {

    const { t } = useTranslation();
    const { company } = useLayoutContext();

    if (!hasSocialLinks(company)) return null;

    return (
        <div className={`flex flex-col gap-0.5 text-base leading-none ${className}`}>
            {!onlyButtons && (
                <h5 className="text-gray-400 text-sm">
                    {t('layout.social_links.title')}
                </h5>
            )}

            <div className="flex w-fit items-center gap-0.5 text-2xl h-full">
                {company?.social_links?.instagram && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.instagram)} rounded className='bg-white'><TbBrandInstagram className='shrink-0' /></Button>}
                {company?.social_links?.facebook && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.facebook)} rounded className='bg-white'><TbBrandFacebook className='shrink-0' /></Button>}
                {company?.social_links?.pinterest && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.pinterest)} rounded className='bg-white'><TbBrandPinterest className='shrink-0' /></Button>}
                {company?.social_links?.x && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.x)} rounded className='bg-white'><TbBrandX className='shrink-0' /></Button>}
                {company?.social_links?.youtube && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.youtube)} rounded className='bg-white'><TbBrandYoutube className='shrink-0' /></Button>}
                {company?.social_links?.tiktok && <Button gray onClick={() => handleNavigateToExternalLink(company?.social_links?.tiktok)} rounded className='bg-white'><TbBrandTiktok className='shrink-0' /></Button>}
            </div>
        </div>
    );
};

export default BoxContentSocial;
